import { IS_SERVER } from '../../common/constants';
import { buildLtpConsentReceiptString, LTP_CONSENT_RECEIPT_DL_KEY } from './ltpConsentReceipt';

/** GTM — align name with container triggers if analytics renames. */
export const LTP_GTM_CONSENT_EVENT = 'ltp-consent-accept';

/**
 * Fired once per document load when consent was already stored (returning visitors).
 * Use in GTM for tags held until consent; distinct from {@link LTP_GTM_CONSENT_EVENT} (fires only on Agree).
 */
export const LTP_GTM_CONSENT_RESTORED_EVENT = 'ltp-consent-restored';

interface WindowWithDataLayer {
  dataLayer?: object[];
}

type ReceiptMode = 'accept' | 'restored';

const pushLtpEvent = (eventName: string, mode: ReceiptMode): void => {
  if (IS_SERVER || typeof window === 'undefined') {
    return;
  }
  const w = (window as unknown) as WindowWithDataLayer;
  w.dataLayer = w.dataLayer || [];
  const receipt = buildLtpConsentReceiptString(mode);
  const payload = {
    event: eventName,
    [LTP_CONSENT_RECEIPT_DL_KEY]: receipt,
  };
  // tslint:disable-next-line:no-console
  console.log('[LTP dataLayer]', payload);
  w.dataLayer.push(payload);
};

export const pushLtpConsentToDataLayer = (): void => {
  pushLtpEvent(LTP_GTM_CONSENT_EVENT, 'accept');
};

/** Call when localStorage already has LTP consent (no modal shown). */
export const pushLtpConsentRestoredToDataLayer = (): void => {
  pushLtpEvent(LTP_GTM_CONSENT_RESTORED_EVENT, 'restored');
};
